import { invokeApi } from '@/common/invokeApi/invokeApi';

import type { Reviewer } from '../types';

export const fetchReviewers = async () =>
  await invokeApi<Reviewer[]>({
    path: '/users/teammates/abilities/reviewers',
  });
